import { CurrencyPipe, formatNumber } from '@angular/common';
import { Option } from '@com-delta-omnichannel/aura';
import { MILES } from '../models';

export const createCurrencyOption = (
  value: number,
  currencyCode: string,
  label: string
): Option => ({
  value: new CurrencyPipe('en-US').transform(value, currencyCode) as string,
  label,
  selected: false
});

export const createMilesOption = (
  value: number,
  label: string
): Option => ({
  value: `${formatNumber(value, 'en-US', '1.0')}${MILES}`,
  label,
  selected: false
});